import type { Champignons } from "@repo/types";

export function getChampignonImageFilename(
  imgUrl: Champignons["img_url"]
): string | null {
  if (!imgUrl) return null;
  if (typeof imgUrl === "string") return imgUrl.trim() || null;
  if (Array.isArray(imgUrl)) {
    const first = imgUrl.find((item) => typeof item === "string" && item.trim());
    return first ?? null;
  }
  if (typeof imgUrl === "object") {
    const record = imgUrl as Record<string, string>;
    const primary = record.img1 ?? Object.values(record).find((value) => typeof value === "string" && value.trim());
    return primary ?? null;
  }
  return null;
}

export function hasChampignonImage(imgUrl: Champignons["img_url"]): boolean {
  return getChampignonImageFilename(imgUrl) !== null;
}
